import AOS from 'aos';

export function aos() {
  AOS.init();
}
